import { Outlet, useLocation } from 'react-router-dom';
import { ModeToggle } from './components/ModeToggle';
import { Toasts } from './components/Toasts';
import { TopNav } from './components/TopNav';
import { isAuthenticated } from './lib/auth';

export function App() {
  const location = useLocation();
  // Login + verify pages render alone (no nav chrome) so the auth surfaces
  // read as deliberate, formal pages.
  const authed = isAuthenticated();
  const onAuthRoute =
    location.pathname.startsWith('/login') || location.pathname.startsWith('/auth/');

  return (
    <>
      <ModeToggle />
      {authed && !onAuthRoute && <TopNav />}
      <Outlet />
      <Toasts />
    </>
  );
}
